import { createSelector } from 'reselect';

import type { RootState } from '@/app/store';

export const selectUserState = (state: RootState) => state.user;

export const selectUser = createSelector(selectUserState, (userState) => userState.data);

export const selectIsAuthenticated = createSelector(
  selectUserState,
  (userState) => userState.isAuthenticated,
);

export const selectUserBalance = createSelector(selectUser, (user) => user?.wallets?.['TON']?.balance ?? 0);

export const selectUserFrozenBalance = createSelector(selectUser, (user) => user?.wallets?.['TON']?.frozenBalance ?? 0);

export const selectWallet = (currency: string) =>
  createSelector(selectUser, (user) => user?.wallets?.[currency] ?? null);

export const selectUserBalanceByCurrency = (currency: string) =>
  createSelector(selectWallet(currency), (wallet) => wallet?.balance ?? 0);

export const selectHasLockedBonus = createSelector(
  selectWallet('TON'),
  selectWallet('STARS'),
  (tonWallet, starsWallet) =>
    (tonWallet?.lockedBonus ?? 0) > 0 || (starsWallet?.lockedBonus ?? 0) > 0,
);

export const selectUserLoading = createSelector(selectUserState, (userState) => userState.loading);

export const selectUserError = createSelector(selectUserState, (userState) => userState.error);

export const selectDepositState = createSelector(
  selectUserState,
  (userState) => userState.deposit,
);

export const selectDepositLoading = createSelector(
  selectDepositState,
  (deposit) => deposit.loading,
);

export const selectDepositError = createSelector(
  selectDepositState,
  (deposit) => deposit.error,
);

export const selectDepositLastTxHash = createSelector(
  selectDepositState,
  (deposit) => deposit.lastTxHash,
);
